var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Not Found")]),_c('router-link',{attrs:{"link-to":"/"}},[_c('h3',[_vm._v("go to Home Page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }